const {ccclass, property} = cc._decorator;

@ccclass
export default class alchemyGame extends cc.Component {

    @property({type:cc.Node,displayName:"按钮Layout"})
    btnLayout:cc.Node = null;

    @property({type:cc.Node,displayName:"开始炼丹按钮"})
    startAlchemyBtn:cc.Node = null;

    @property({type:cc.Node,displayName:"一键炼丹按钮"})
    autoAlchemyBtn:cc.Node = null;

    @property({type:cc.Node,displayName:"放置燃料的盖子"})
    gaiBig:cc.Node = null;

    @property({type:cc.Node,displayName:"放置物品按钮"})
    gaiSmall:cc.Node = null;

    @property({type:cc.Node,displayName:"进度条"})
    progress:cc.Node = null;

    onLoad(){

    }

    onBtnStartAlchemy(){
        
    }
    
    onBtnAutoAlchemy(){

    }

    //放置物品动画
    pushArticleAni(){

    }
    //放置燃料动画
    pushFuelAni(){

    }
    //放置一个物品
    pushOneArticle(){

    }
    //放置一个燃料
    pushOneFuel(){

    }




}
